import { ReactNode } from 'react';
import classes from 'classnames';
import styles from './Placeholder.module.scss';

export type Props = {
  children?: ReactNode;
  className?: string;
  dataTest?: string;
  placeholder?: string;
  loading?: boolean;
  /** Replace current children with placeholder */
  replace?: boolean;
};

export default function Placeholder({
  children,
  className,
  loading,
  placeholder = 'Loading',
  dataTest = 'placeholder',
  replace = false,
}: Props) {
  return (
    <span
      className={classes(loading && styles.wrapper, className)}
      data-test={dataTest}
    >
      {(children || children === 0) && (!replace || !loading)
        ? children
        : placeholder}
    </span>
  );
}
